export default function LoaderPremiumLogo() {
  return (
    <div className="flex justify-center items-center h-[100vh] bg-gradient-to-b from-white via-slate-100 to-[#eef3f9]">
      <div className="relative flex justify-center items-center">

        {/* ORBITA BRILLANTE */}
        <div className="
          absolute w-56 h-56 rounded-full
          border-[6px] border-[#1E4A85]/30
          border-t-[#1E4A85] border-l-transparent
          blur-[1px]
          animate-spin-slow
        "></div>

        {/* ORBITA SECUNDARIA */}
        <div className="
          absolute w-40 h-40 rounded-full
          border-[4px] border-[#1E4A85]/20 
          border-b-[#1E4A85]
          animate-spin-reverse
        "></div>

        {/* GLOW CENTRAL MÁS FUERTE */}
        <div className="
          absolute w-44 h-44
          bg-[#1E4A85]/40 
          blur-3xl rounded-full
          animate-pulse
        "></div>

        {/* LOGO SUPER PREMIUM */}
        <img
          src="/IP_DEPOT_Optimizado.png"
          alt="IP Depot Logo"
          className="
            relative w-40 h-auto 
            drop-shadow-[0_0_18px_rgba(30,74,133,0.45)]
            animate-logo-pop
          "
        />

      </div>
    </div>
  );
}
